import { Grid, Box, Button } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { FunnelSimple } from '@phosphor-icons/react';
import { safeFormatDateToISOString, parseISODate } from 'utils/date';
import LocalizationProvider from 'components/LocalizationProvider';
import { useHomeContext } from '../context';
import Filter from './Filter';

const ListHeader = ():JSX.Element => {
  const {
    statusFilters,
    setStatusFilters,
    kindFilters,
    setKindFilters,
    showFilter,
    setShowFilter,
    monthFilter,
    setMonthFilter,
  } = useHomeContext();

  const hasFilters = statusFilters.length > 0 || kindFilters.length > 0;

  const filters = [...statusFilters, ...kindFilters];

  const filtereds = filters.map((filter) => filter.label).join(', ');

  const cleanFilters = () => {
    setStatusFilters([]);
    setKindFilters([]);
    setMonthFilter(undefined);
  };

  return (
    <Grid size={12}>
      <Box width="100%" display="flex" justifyContent="flex-end" alignItems="center">
        <Box mr={2} marginBottom={1.5}>
          <LocalizationProvider>
            <DesktopDatePicker
              openTo="year"
              views={['year', 'month']}
              label="Mês de afiliação"
              value={parseISODate(monthFilter)}
              onChange={(value) => setMonthFilter(safeFormatDateToISOString(value as Date))}
            />
          </LocalizationProvider>
        </Box>
        <Button
          variant="contained"
          size="large"
          sx={{ backgroundColor: '#fff' }}
          endIcon={<FunnelSimple size={16} />}
          onClick={() => setShowFilter(true)}
        >
          Filtros
          {hasFilters && ` - ${filtereds}`}
        </Button>
        {hasFilters && (
        <Button
          size="large"
          color="primary"
          onClick={cleanFilters}
        >
          Limpar
        </Button>
        )}
        {showFilter && (
          <Box position="absolute" zIndex={10}>
            <Filter />
          </Box>
        )}
      </Box>
    </Grid>
  );
};

export default ListHeader;
